import React, { useEffect, useState, useCallback, useRef } from "react";
import { Spinner } from "components/common";
import OidcLoginForm from "./OidcLoginForm";
import { OidcSessionActions } from "./OidcSessionStore";
import { LoginMetricsActions } from "./LoginMetricsStore";
import { createFailureLoginMetric, GRAYLOG_ERROR_CODES } from "./LoginMetrics";
const OidcCallback = ({ configuration, nonce, onErrorChange, params, regenerateNonce }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const isRegenerated = useRef(false);
  const generateNonce = useCallback(() => {
    if (!isRegenerated.current) {
      regenerateNonce();
      isRegenerated.current = true;
    }
  }, [regenerateNonce]);
  useEffect(() => {
    const handleLoginFailure = (metric) => {
      if (metric) {
        LoginMetricsActions.post(metric);
      }
      setLoginFailed(true);
      generateNonce();
    };
    if (loginFailed) {
      return () => {
      };
    }
    if (params.error_description) {
      onErrorChange(params.error_description);
      handleLoginFailure(createFailureLoginMetric("login", "gl", GRAYLOG_ERROR_CODES.oktaLoginRedirectError));
      return () => {
      };
    }
    if (nonce.state !== params.state) {
      onErrorChange(
        "A possible CSRF attempt has been detected, the state parameter does not match the request. Please contact an administrator."
      );
      handleLoginFailure(createFailureLoginMetric("tokenExchange", "gl", GRAYLOG_ERROR_CODES.nonceMismatch));
      return () => {
      };
    }
    setIsLoading(true);
    const promise = OidcSessionActions.login(params.code);
    promise.catch((error) => {
      if (error.status === 401) {
        onErrorChange("Login failed. This might be a temporary problem. Please try again.");
      } else {
        onErrorChange("Unknown error, please retry or contact an administrator.");
      }
      handleLoginFailure();
      setIsLoading(false);
      return error;
    });
    return () => {
      var _a;
      if (promise) {
        (_a = promise.cancel) == null ? void 0 : _a.call(promise);
      }
    };
  }, [generateNonce, loginFailed, nonce.state, onErrorChange, params]);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement("p", { className: "loading-text" }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading, please wait...", delay: 0 }));
  }
  return /* @__PURE__ */ React.createElement(OidcLoginForm, { configuration, nonce });
};
export default OidcCallback;
